export function isUsLocale(locale: string) {
  return locale === 'en_US' || locale === 'en-US';
}

export function isGermanLocale(locale: string) {
  return locale === 'de_DE' || locale === 'de-DE';
}

export function isIcelandLocale(locale: string) {
  return locale === 'is_IS' || locale === 'is-IS';
}
